import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Loader } from 'components/loader/loader';
import { css } from 'linaria';
const loadMoreStyle = "ld5klde";
export function LoadMore({
  count,
  total,
  loadMore
}) {
  const {
    ref,
    inView
  } = useInView();
  useEffect(() => {
    if (!inView) return; // There are more items to load! Let's do it

    if (count < total) {
      loadMore();
    }
  }, [inView, count, total, loadMore]);
  return count < total ? <div key="load-more" className={loadMoreStyle} ref={ref}>
      Loading more items <Loader />
    </div> : null;
}

require("./load-more.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./load-more.js");